var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA1PlugUnplug(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 53h13v4H60a13.6 13.6 0 01-13.44 12H41V41h5.56A13.7 13.7 0 0160 53zM51.56 7H46v28h5.56A13.6 13.6 0 0065 23h8v-4h-8A13.7 13.7 0 0051.56 7zM42 28a2 2 0 00-2-2h-9V16h9a2 2 0 000-4h-9V7h-5.67a13.82 13.82 0 00-13.57 12H3v4h8.73a13.72 13.72 0 0013.6 12H31v-5h9a2 2 0 002-2zM15.76 53H3v4h12.73a13.72 13.72 0 0013.6 12H35V41h-5.67a13.82 13.82 0 00-13.57 12z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A1_Plug_Unplug.9efab630.svg";
export { SvgA1PlugUnplug as ReactComponent };